import approveGQL from "@/Apollo/mutation/agent-oauth/approveAgentAuthorization.graphql";
import denyGQL from "@/Apollo/mutation/agent-oauth/denyAgentAuthorization.graphql";
import revokeGQL from "@/Apollo/mutation/agent-oauth/revokeAgentGrant.graphql";
import requestGQL from "@/Apollo/query/agent-oauth/agentAuthorizationRequest.graphql";
import grantsGQL from "@/Apollo/query/agent-oauth/agentGrants.graphql";
import {
  AgentAuthorizationRequestQuery,
  AgentAuthorizationRequestQueryVariables,
  AgentGrantsQuery,
  AgentGrantsQueryVariables,
  ApproveAgentAuthorizationMutation,
  ApproveAgentAuthorizationMutationVariables,
  DenyAgentAuthorizationMutation,
  DenyAgentAuthorizationMutationVariables,
  RevokeAgentGrantMutation,
  RevokeAgentGrantMutationVariables,
} from "@/Apollo/schema";
import {
  MutationHookOptions,
  QueryHookOptions,
  useMutation,
  useQuery,
} from "@apollo/client";

/** WHO-6316: AI assistant sign-in (consent page and connected assistants). */
export const useAgentAuthorizationRequest = (
  options?: QueryHookOptions<
    AgentAuthorizationRequestQuery,
    AgentAuthorizationRequestQueryVariables
  >
) => useQuery(requestGQL, options);

export const useAgentGrants = (
  options?: QueryHookOptions<AgentGrantsQuery, AgentGrantsQueryVariables>
) => useQuery(grantsGQL, options);

export const useApproveAgentAuthorization = (
  options?: MutationHookOptions<
    ApproveAgentAuthorizationMutation,
    ApproveAgentAuthorizationMutationVariables
  >
) => useMutation(approveGQL, options);

export const useDenyAgentAuthorization = (
  options?: MutationHookOptions<
    DenyAgentAuthorizationMutation,
    DenyAgentAuthorizationMutationVariables
  >
) => useMutation(denyGQL, options);

export const useRevokeAgentGrant = (
  options?: MutationHookOptions<
    RevokeAgentGrantMutation,
    RevokeAgentGrantMutationVariables
  >
) => useMutation(revokeGQL, options);
